import { Component } from 'react';
import QuestionComponent from './QuestionComponent';
import * as React from 'react';
import { Grid } from '@material-ui/core';
import { updateQuestionVisibility, updateQuestionValue } from 'src/effects/utils/preview';
import ReactHtmlParser from 'react-html-parser';
import { QuestionType } from '../../constants/Enum/ModuleEnum';

export default class ClusterComponent extends Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            showCommentsDialog: false,
            isClusterHidden: false
        };

        this.updateQuestion = this.updateQuestion.bind(this);
        this.updateQuestionVisibility = this.updateQuestionVisibility.bind(this);
        this.addQuestionComment = this.addQuestionComment.bind(this);
        this.loaderVisibility = this.loaderVisibility.bind(this);
    }

    loaderVisibility(data: any) {
        this.props.loaderVisibility(data);
    }

    addQuestionComment(updateQuestionCommentData: any) {
        this.props.addQuestionComment(updateQuestionCommentData);
    }

    updateQuestion(updateQuestionData: any) {
        this.props.updateQuestion(updateQuestionData);
    }

    updateQuestionVisibility(updateQuestionVisibilityData: any) {
        this.props.updateQuestionVisibility(updateQuestionVisibilityData)
    }


    componentDidMount() {
        for (const question of this.props.cluster.questions) {
            this.visibleIfConditions(this.props, question);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {

        nextProps.pages.forEach((page: any) => {
            for (const cluster of page.page.question_clusters) {
                for (const question of cluster.questions) {
                    this.visibleIfConditions(nextProps, question);
                }
            }
        });

    }

    getQuestionByQuestionId(questionId: any) {
        const questionMetadata = {
            clusterIndex: 0,
            pageIndex: 0,
            questionIndex: 0,
            question: undefined,
            questionId: 0
        }


        for (let pageIndex: any = 0; pageIndex < this.props.pages.length; pageIndex++) {
            const page = this.props.pages[pageIndex];
            for (let clusterIndex: any = 0; clusterIndex < page.page.question_clusters.length; clusterIndex++) {
                for (let questionIndex: any = 0; questionIndex < page.page.question_clusters[clusterIndex].questions.length; questionIndex++) {
                    const questionData = page.page.question_clusters[clusterIndex].questions[questionIndex];
                    if (questionData && questionData.question_id === questionId) {
                        questionMetadata.pageIndex = pageIndex;
                        questionMetadata.clusterIndex = clusterIndex;
                        questionMetadata.questionIndex = questionIndex;
                        questionMetadata.questionId = questionId;
                        questionMetadata.question = questionData;
                        return questionMetadata;
                    }
                }
            }
        }

        return questionMetadata;
    }


    visibleIfConditions(newProps: any, question: any) {
        let isVisible = true;
        let questionMetaData: any;
        for (let index = 0; index < question.visibleIf.length; index++) {
            const questionData: any = this.visibleIfConditionCheck(question.visibleIf[index], newProps, question);

            if (index === 0) {
                questionMetaData = questionData.questionMetadata;
            }

            if (!questionData.shouldVisible) {
                isVisible = false;
            }
            else {
                isVisible = true;
                break;
            }

        }

        if (questionMetaData) {
            if (isVisible) {
                if (!question.is_visible) {
                    updateQuestionVisibility(newProps, questionMetaData, true);
                }
            }
            else if (!isVisible) {
                if (question.is_visible) {
                    updateQuestionVisibility(newProps, questionMetaData, false);
                    this.resetQuestionResponse(questionMetaData.questionId, !isVisible)
                }
            }
        }
    }
    resetQuestionResponse(questionId: any, isVisibleDepend: boolean) {
        const questionMetadata = this.getQuestionByQuestionId(questionId);
        const question: any = questionMetadata.question;

        if (question) {

            if (question.class_type === 1) {
                switch (question.input_type) {
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        {
                            this.resetAllQuestionTypeExceptCheckboxValue(0, question, questionMetadata);
                        }
                        break;
                    case 6:
                        {
                            this.resetCheckboxTypeQuestionValue(0, question, questionMetadata, isVisibleDepend);
                        }
                        break;
                    case 7:
                        {
                            this.resetAdminQuestionTypeValue(0, question, questionMetadata)
                        }
                }
            } else {
                if (question.input_type === QuestionType.AdminLevel) {
                    this.resetAdminQuestionTypeValue(0, question, questionMetadata);
                }
            }

            if (question.class_type === 2) {
                switch (question.input_type) {
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        {
                            this.resetAllQuestionTypeExceptCheckboxValue(0, question, questionMetadata);
                            this.resetAllQuestionTypeExceptCheckboxValue(1, question, questionMetadata);
                        }
                        break;
                    case 6:
                        {
                            this.resetCheckboxTypeQuestionValue(0, question, questionMetadata);
                            this.resetCheckboxTypeQuestionValue(1, question, questionMetadata);
                        }
                        break;
                }
            }

            if (question.class_type === 3) {
                switch (question.input_type) {
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                        {
                            this.resetAllQuestionTypeExceptCheckboxValue(0, question, questionMetadata);
                            this.resetAllQuestionTypeExceptCheckboxValue(1, question, questionMetadata);
                            this.resetAllQuestionTypeExceptCheckboxValue(2, question, questionMetadata);
                        }
                        break;
                    case 6:
                        {
                            this.resetCheckboxTypeQuestionValue(0, question, questionMetadata);
                            this.resetCheckboxTypeQuestionValue(1, question, questionMetadata);
                            this.resetCheckboxTypeQuestionValue(2, question, questionMetadata);
                        }
                        break;
                }
            }
        }
    }

    resetAllQuestionTypeExceptCheckboxValue(index: any, question: any, questionMetadata: any) {
        if (question.question_responses[index].value !== '') {
            updateQuestionValue(this.props, questionMetadata.pageIndex, questionMetadata.clusterIndex, questionMetadata.questionIndex, question.question_number, index + 1, '', false, null, true, ['']);
        }
    }

    resetAdminQuestionTypeValue(index: any, question: any, questionMetadata: any) {
        if (question.question_admin_responses && question.question_admin_responses.length > 0) {
            let isReset: boolean = false;
            question.question_admin_responses.forEach((adminResponse: any) => {
                if (adminResponse.value !== '') {
                    adminResponse.value = '';
                    isReset = true;
                }
            })

            if (isReset) {
                updateQuestionValue(this.props, questionMetadata.pageIndex, questionMetadata.clusterIndex, questionMetadata.questionIndex, question.question_number, index + 1, '', false, null, true, ['']);
            }
        }
    }

    resetCheckboxTypeQuestionValue(index: any, question: any, questionMetadata: any, isVisibleDepend?: boolean) {
        if (question.question_responses[index].value && question.question_responses[index].value.length > 0) {
            const defaultValues = question.default_question_responses && question.default_question_responses[index] && question.default_question_responses[index].value ? JSON.parse(JSON.stringify(question.default_question_responses[index].value)) : [];
            let isAnyOptionSelected = false;
            const options = question.question_responses[0].value;

            for (const currentOption of options) {
                if (currentOption.value) {
                    isAnyOptionSelected = true;
                    break;
                }
            }

            if (isAnyOptionSelected) {
                for (const currentOption of options) {
                    currentOption.value = false;
                }

                if (isVisibleDepend && defaultValues) {
                    if(questionMetadata.question.default_question_responses[index] !== undefined) {
                    questionMetadata.question.default_question_responses[index].value = defaultValues;
                     }
                }
            }
            
            updateQuestionValue(this.props, questionMetadata.pageIndex, questionMetadata.clusterIndex, questionMetadata.questionIndex, question.question_number, index + 1, options, false, null, true, [''], isVisibleDepend);
        }
    }


    visibleIfConditionCheck(visibleCondition: any, newProps: any, questionProp: any) {
        const questionData = {
            shouldVisible: true,
            questionId: '',
            question: {},
            questionMetadata: {}
        };

        if (newProps && newProps.pages) {
            for (const page of newProps.pages) {
                for (const cluster of page.page.question_clusters) {
                    for (const question of cluster.questions) {

                        questionData.questionMetadata = this.getQuestionByQuestionId(questionProp.question_id);
                        questionData.questionId = question.question_id;
                        questionData.question = question;

                        if (visibleCondition.set_no !== undefined
                            && visibleCondition.question_id === question.question_id
                            && question.question_responses.length >= visibleCondition.set_no) {
                            switch (visibleCondition.operator) {
                                case "=":
                                    questionData.shouldVisible = question.question_responses[visibleCondition.set_no - 1].value === visibleCondition.value ? true : false;
                                    break;

                                case "!=":
                                    questionData.shouldVisible = question.question_responses[visibleCondition.set_no - 1].value !== visibleCondition.value ? true : false;
                                    break;

                                case ">":
                                    questionData.shouldVisible = this.visibleIfGreaterThanCheck(question, questionData, visibleCondition);
                                    break;

                                case "<":
                                    questionData.shouldVisible = this.visibleIfLessThanCheck(question, questionData, visibleCondition);
                                    break;

                                case ">=":
                                    questionData.shouldVisible = this.visibleIfGreaterThanEqualCheck(question, questionData, visibleCondition);
                                    break;

                                case "<=":
                                    questionData.shouldVisible = this.visibleIfLessThanEqualCheck(question, questionData, visibleCondition);
                                    break;

                                default:
                                    questionData.shouldVisible = true;
                                    break;
                            }

                        }

                    }
                }
            }
        }

        return questionData;
    }

    visibilityCommonCheck(question: any) {
        switch (question.input_type) {
            case 1:
            case 4:
            case 5:
                // case 6:
                {
                    return true;
                }
                break;
        }
        return false;
    }

    visibilityRadioCheck(question: any) {
        switch (question.input_type) {
            case 1:
            case 4:
                // case 6:
                {
                    return true;
                }
                break;
        }
        return false;
    }

    visibleIfGreaterThanCheck(question: any, questionData: any, visibleCondition: any) {
        if (!this.visibilityRadioCheck(question)) {
            switch (question.input_type) {
                case 2:
                case 5:
                    {
                        return parseInt(question.question_responses[visibleCondition.set_no - 1].value, 10) > parseInt(visibleCondition.value, 10) ? true : false;
                    }
                    break;
                case 3:
                    {
                        return Date.parse(question.question_responses[visibleCondition.set_no - 1].value) > Date.parse(visibleCondition.value) ? true : false;
                    }
                    break;
            }
        }

        return true;
    }

    visibleIfLessThanCheck(question: any, questionData: any, visibleCondition: any) {
        if (!this.visibilityCommonCheck(question)) {
            switch (question.input_type) {
                case 2:
                    {
                        return parseInt(question.question_responses[visibleCondition.set_no - 1].value, 10) < parseInt(visibleCondition.value, 10) ? true : false;
                    }
                    break;
                case 3:
                    {
                        return Date.parse(question.question_responses[visibleCondition.set_no - 1].value) < Date.parse(visibleCondition.value) ? true : false;
                    }
                    break;
            }
        }

        return true;
    }

    visibleIfGreaterThanEqualCheck(question: any, questionData: any, visibleCondition: any) {
        if (!this.visibilityCommonCheck(question)) {
            switch (question.input_type) {
                case 2:
                    {
                        return parseInt(question.question_responses[visibleCondition.set_no - 1].value, 10) >= parseInt(visibleCondition.value, 10) ? true : false;
                    }
                    break;
                case 3:
                    {
                        return Date.parse(question.question_responses[visibleCondition.set_no - 1].value) >= Date.parse(visibleCondition.value) ? true : false;
                    }
                    break;
            }
        }

        return true;
    }

    visibleIfLessThanEqualCheck(question: any, questionData: any, visibleCondition: any) {
        if (!this.visibilityCommonCheck(question)) {
            switch (question.input_type) {
                case 2:
                    {
                        return parseInt(question.question_responses[visibleCondition.set_no - 1].value, 10) <= parseInt(visibleCondition.value, 10) ? true : false;
                    }
                    break;
                case 3:
                    {
                        return Date.parse(question.question_responses[visibleCondition.set_no - 1].value) <= Date.parse(visibleCondition.value) ? true : false;
                    }
                    break;
            }
        }

        return true;
    }


    getQuestionResponses(question: any) {

        const setOneResponse = question.question_responses[0].value;
        let setTwoResponse;
        let setThreeResponse;

        if (question.class_type === 2) {
            setTwoResponse = question.question_responses[1].value;
        }
        if (question.class_type === 3) {
            setTwoResponse = question.question_responses[1].value;
            setThreeResponse = question.question_responses[2].value;
        }

        const response = {
            setOneResponse,
            setTwoResponse,
            setThreeResponse
        };

        return response;
    }


    render() {

        return (
            <>
                {
                    this.props.cluster && !this.props.cluster.is_hidden ?
                        <>
                            {this.props.cluster.questions.length > 0 ?
                                <div key={'cluster-div' + this.props.clusterIndex} className="cluster">
                                    <Grid container={true} spacing={8}>
                                        <Grid xs={12} item={true}>
                                            <div className="pagePreviewClusterSection">
                                                <Grid container={true} spacing={24}>
                                                    <Grid item={true} xs={12}>
                                                        <div><h4>{this.props.cluster.title ? this.props.cluster.title.en : ''}</h4></div>
                                                        <div>
                                                            <p>
                                                                {this.props.cluster.cluster_description ? ReactHtmlParser(this.props.cluster.cluster_description.en) : ReactHtmlParser('')}
                                                            </p>
                                                        </div>
                                                    </Grid>
                                                </Grid>
                                            </div>

                                            <div className="questions">
                                                {

                                                    this.props.cluster.questions.map((question: any, key: any) => {
                                                        return <QuestionComponent
                                                            pages={this.props.pages}
                                                            pageNumber={this.props.pageNumber}
                                                            pagePreview={this.props.pagePreview}
                                                            updateQuestion={this.updateQuestion}
                                                            updateQuestionVisibility={this.updateQuestionVisibility}
                                                            addQuestionComment={this.addQuestionComment}
                                                            clusterIndex={this.props.clusterIndex}
                                                            questionIndex={key}
                                                            questionId={question.question_id}
                                                            key={'question-component' + key}
                                                            question={question}
                                                            countryModuleSurveyMappingId={this.props.countryModuleSurveyMappingId}
                                                            moduleId={this.props.moduleId}
                                                            surveyStatus={this.props.surveyStatus}
                                                            surveyType={this.props.surveyType}
                                                            isResponsePage={this.props.isResponsePage}
                                                            loaderVisibility={this.loaderVisibility}
                                                            isOfflineMode={this.props.isOfflineMode}
                                                            isShowRecentData={this.props.isShowRecentData}
                                                        />
                                                    })

                                                }

                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>
                                :
                                ''
                            }
                        </>
                        :
                        ''
                }
            </>

        )
    }
}



// WEBPACK FOOTER //
// ./src/components/responses/ClusterComponent.tsx